import api from './api';

const practiceService = {
  // Get all practices
  async getAll() {
    return api.get('/practices');
  },

  // Get practice by ID
  async getById(id) {
    return api.get(`/practices/${id}`);
  },

  // Create new practice
  async create(practiceData) {
    return api.post('/practices', practiceData);
  },

  // Update practice
  async update(id, practiceData) {
    return api.put(`/practices/${id}`, practiceData);
  },

  // Enable practice
  async enable(id) {
    return api.post(`/practices/${id}/enable`);
  },

  // Disable practice
  async disable(id) {
    return api.post(`/practices/${id}/disable`);
  },

  // Get sender configuration for a practice
  async getSenderConfig(id) {
    return api.get(`/practices/${id}/sender-config`);
  },

  // Update sender configuration for a practice
  async updateSenderConfig(id, senderConfig) {
    return api.put(`/practices/${id}/sender-config`, senderConfig);
  },

  // Landing page
  async getLandingPageStatus(id) {
    return api.get(`/practices/${id}/landing-page`);
  },

  async publishLandingPage(id) {
    return api.post(`/practices/${id}/landing-page/publish`);
  },

  async unpublishLandingPage(id) {
    return api.post(`/practices/${id}/landing-page/unpublish`);
  },

  getLandingPagePreviewUrl(id) {
    return `/api/practices/${id}/landing-page/preview`;
  }
};

export default practiceService;
